import { Component } from '@angular/core';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'lib-mcard-events-test-component',
  templateUrl: './m-card-events-test.component.html',
  styleUrl: './m-card-events-test.component.scss',
  imports: [MatFormFieldModule, ReactiveFormsModule]
})
export class MCardEventsTestComponent {

  campaignIdFormControl = new FormControl(null, Validators.required);

  event?: string;

  constructor(activatedRoute: ActivatedRoute) {
    this.event = activatedRoute.snapshot.queryParams['event'];
  }

  fireFreeMoneyRedeem(): void {
    if(this.campaignIdFormControl.valid && this.event) {
      EventFireHelper.fire(this.event, {campaignId: this.campaignIdFormControl.value});
    }
  }
}

const win =
  typeof window === 'undefined'
    ? { fireAngularEvent: (...args: any) => {} }
    : window;

export class EventFireHelper {
  public static fire(eventName: string, data: any) {
    (win as any)['mCardEvent'](eventName, data);
  }
}
